<template>
  <asc-container class="asc-terms-conditions-template">
    <asc-terms-and-conditions />
    <span
      v-if="termsAcceptance.accepted === true"
      class="asc-terms-and-conditions--footer__text"
    >
      Accepted on {{ formatAcceptanceDate }}
    </span>
  </asc-container>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscTermsAndConditions from '@/components/atoms/AscTermsAndConditions'
import moment from 'moment'

export default {
  name: 'AscTermsConditionsTemplate',

  components: {
    AscContainer,
    AscTermsAndConditions,
  },

  props: {
    termsAcceptance: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    formatAcceptanceDate() {
      return moment(this.termsAcceptance.lastAcceptedOn).format('MMMM DD, YYYY')
    },
  },
}
</script>

<style lang="scss">
.asc-terms-conditions-template {
  height: calc(100vh - 120px);

  .asc-terms-and-conditions--footer__text {
    display: inline-block;
    width: 100%;
    text-align: center;
    margin: 20px 0;
    color: $gray-700;
    font-size: $font-size-md;
  }

  .asc-header--h4 {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 18px;
    margin-bottom: 16px;
  }
}

@media (max-width: 950px) {
  .asc-terms-conditions-template {
    height: auto;
  }
}
</style>
